/* eslint-disable react/forbid-prop-types */
/* eslint-disable prefer-template */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  BsCurrencyDollar,
  BsCurrencyEuro,
  BsCurrencyPound,
} from 'react-icons/bs';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import AppButton from '../../shared/components/app-button/AppButton';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import { getCurrencySymbol } from '../../shared/helper-utils/appUtils';
// import './RefineResults.scss';

const currencies = [
  {
    name: 'Indian Rupees',
    icon: <span className="ms-1">{getCurrencySymbol()}</span>,
    value: 'inr',
  },
  { name: 'United States Dollar', icon: <BsCurrencyDollar />, value: 'usd' },
  { name: 'British Pounds', icon: <BsCurrencyPound />, value: 'bp' },
  { name: 'Euro', icon: <BsCurrencyEuro />, value: 'euro' },
];
function RefineResults({ handleClose }) {
  const [currency, setCurrency] = useState('inr');
  return (
    <div className="refine-results-page">
      <div className="d-flex align-items-center border-bottom-2 pb-3 font-weight-600 dark-grey-color">
        <MdKeyboardArrowLeft style={{ fontSize: 32 }} />
        <span style={{ fontSize: 16 }}>Currency</span>
      </div>
      <div>
        {currencies.map((d) => (
          <div
            key={d.name}
            className="d-flex justify-content-between align-items-center pt-2 pb-2 border-bottom dark-grey-color"
            style={{ fontWeight: 400, fontSize: 16 }}
          >
            <div>
              {d.icon}
              <span>{` • ${d.name}`}</span>
            </div>
            <AppRadioInput
              id="currency"
              name="currency"
              labelText=""
              value={d.value}
              onChange={(event) => setCurrency(event.target.value)}
              checked={currency === d.value}
            />
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-center pt-3">
        <AppButton btnText="Done" onClick={handleClose} />
      </div>
    </div>
  );
}

RefineResults.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default RefineResults;
